// prop-type is a library for typechecking of props
import PropTypes from 'prop-types'
import { useState } from 'react'
// Soft UI Dashboard PRO React components
import FormField from 'components/FormField'
import { useFieldState } from 'hooks/useFieldState'
import { NumericFormat } from 'react-number-format'

const IntegerField = ({
  value,
  label,
  onChange,
  required,
  placeholder,
  maxValue,
  onBlur,
  ...rest
}) => {
  const [rawValue, setRawValue] = useState(value)
  const fieldLimit = maxValue || 1000
  const validateInt = (value) => {
    if (value > fieldLimit) return false
    return `${value}`.match(/^\d+$/)
  }
  const { isError, isSuccess, handleOnblur } = useFieldState({
    required,
    validatorFunction: validateInt,
  })
  const handleOnblurWithValidation = (value) => {
    const isValid = validateInt(value)
    handleOnblur?.(value)
    if (isValid && value <= fieldLimit) {
      onBlur?.(rawValue)
    }
  }
  return (
    <>
      <NumericFormat
        value={value}
        label={label}
        placeholder={placeholder}
        inputProps={{ inputMode: 'numeric' }}
        customInput={FormField}
        error={isError}
        success={isSuccess}
        onBlur={handleOnblurWithValidation}
        onValueChange={(values) => {
          if (values.floatValue <= fieldLimit) {
            setRawValue(values.value)
            onChange(values.value)
          }
        }}
        {...rest}
      />
    </>
  )
}

// typechecking props for IntegerField
IntegerField.propTypes = {
  label: PropTypes.string.isRequired,
}

export default IntegerField
